import React from 'react';
import { observer } from 'mobx-react-lite';
import { StatisticsIntervalTypeEnum } from '@app/common';
import { STATISTIC_INTERVALS } from '../../../../models/stores/statistic/statistic-store';
import { ButtonFilter } from '../../form/button-filter/button-filter';
import SkeletonButton from '../../skeleton/button/skeleton-button';

type PeriodSwitcherSkeletonProps = {
    excludedTypes?: StatisticsIntervalTypeEnum[];
};

export const PeriodSwitcherSkeleton: React.FC<PeriodSwitcherSkeletonProps> = observer(({ excludedTypes }) => {
    const intervals = STATISTIC_INTERVALS.filter((period) => !excludedTypes?.includes(period.type));

    return (
        <div className="flex w-full justify-start overflow-x-auto overflow-y-hidden [-webkit-overflow-scrolling:touch] [scrollbar-width:none] xl:justify-end [&::-webkit-scrollbar]:hidden">
            <div className="inline-flex">
                <ButtonFilter>
                    {intervals.map((period) => {
                        return (
                            <SkeletonButton key={period.title} size={{ xs: 'vsmall', md: 'small' }}>
                                {period.title}
                            </SkeletonButton>
                        );
                    })}
                </ButtonFilter>
            </div>
        </div>
    );
});
